/**
 * Onde o menu do "Mais ações" mora e quando ele fecha ao rolar (v2.1, p.30).
 *
 * Achado dos robôs no QAS (20/10/2026): o menu fechava em QUALQUER rolagem — e
 * o próprio clique rola. O botão de três pontos fica numa célula fixa da linha;
 * quando a linha está meio escondida (sob a barra de salvar, na borda da
 * tabela), o navegador rola a página para mostrar o botão que ganhou foco, e
 * o menu abria e fechava no mesmo instante.
 *
 * A regra agora: rolar faz o menu ACOMPANHAR o gatilho; ele só fecha quando o
 * gatilho sai da tela — aí, sim, o menu apontaria para o nada.
 */
export interface Retangulo {
  readonly top: number;
  readonly bottom: number;
  readonly right: number;
}

export interface Janela {
  readonly largura: number;
  readonly altura: number;
}

export type LugarDoMenu = { readonly direita: number } & ({ readonly topo: number } | { readonly base: number });

/** A altura do menu pelas linhas que ele vai ter: o item mede 40 px, e o motivo de indisponível acrescenta uma linha. */
export function alturaDoMenu(acoes: readonly { readonly motivoIndisponivel?: string }[]): number {
  return 8 + acoes.reduce((soma, a) => soma + (a.motivoIndisponivel ? 60 : 40), 0);
}

/** Colado ao gatilho, a 8 px, alinhado pela direita; embaixo, ou em cima quando embaixo não cabe (R01, p.29). */
export function lugarDoMenu(gatilho: Retangulo, altura: number, janela: Janela): LugarDoMenu {
  const direita = janela.largura - gatilho.right;
  const cabeEmbaixo = janela.altura - gatilho.bottom - 8 >= altura || gatilho.top < altura;
  return cabeEmbaixo ? { direita, topo: gatilho.bottom + 8 } : { direita, base: janela.altura - gatilho.top + 8 };
}

/**
 * O que a rolagem faz com o menu aberto: `seguir` enquanto o gatilho continua
 * visível (inclusive a rolagem que o próprio clique provocou), `fechar` quando
 * ele sai da tela.
 */
export function decidirNaRolagem(gatilho: Retangulo, janela: Janela): 'seguir' | 'fechar' {
  const visivel = gatilho.bottom > 0 && gatilho.top < janela.altura;
  return visivel ? 'seguir' : 'fechar';
}
